<template>
  <div class="flex flex-col gap-1 mb-8">
    <div class="flex items-center gap-1">
      <PButton size="icon" class="mr-1">
        <OhVueIcon :name="userProfileIcon" />
      </PButton>
      <p>
        Avec ce bouton, vous pouvez accéder à tout moment à votre profil qui vous permettra de gérer facilement les
        notifications, vos griffes pour signer,
        <span class="font-bold">déclarer votre changement de poste</span> ou télécharger vos parapheurs, mais aussi
        revoir le tutoriel de l'application.
      </p>
    </div>
    <PAccordion label="Notification" label-tag="h2" class="py-1 [&>button]:border-grey-625 border-b-grey-625">
      Je peux sélectionner parmi les 4 modalités proposées le rythme de notification
      <ul>
        <li>
          <OhVueIcon :name="checkIcon" class="text-green-bourgeon-850 mr-1" />
          En temps réel
        </li>
        <li>
          <OhVueIcon :name="checkIcon" class="text-green-bourgeon-850 mr-1" />
          1 fois par jour à 10h
        </li>
        <li>
          <OhVueIcon :name="checkIcon" class="text-green-bourgeon-850 mr-1" />
          2 fois par jour à 10h et 15h
        </li>
        <li>
          <OhVueIcon :name="checkIcon" class="text-green-bourgeon-850 mr-1" />
          Pas de notification
        </li>
      </ul>
    </PAccordion>
    <PAccordion
      label="Déclaration de changement de poste"
      label-tag="h2"
      class="py-1 [&>button]:border-grey-625 border-b-grey-625"
    >
      <p>
        Je déclare mon changement de poste au moment ou juste après sa date effective. Plus aucun des parapheurs créés
        avant cette date ne me sera accessible dans mon nouveau poste.
      </p>
    </PAccordion>
    <PAccordion label="Griffe de signature" label-tag="h2" class="py-1 [&>button]:border-grey-625 border-b-grey-625">
      <p>
        Je gère mes griffes signatures directement à ce niveau. Le cas échéant, je choisis ma griffe par défaut. Et je
        clique sur "Enregistrer"
      </p>
      <p>À noter : vous pouvez ajouter une signature directement depuis le module de signature</p>
    </PAccordion>
    <PAccordion label="Fonction et ville" label-tag="h2" class="py-1 [&>button]:border-grey-625 border-b-grey-625">
      <p>Lors de la création de mon compte, ma fonction et ma ville sont récupérées de l'annuaire ministériel.</p>
      <p>Je peux les modifier dans l'onglet "Signatures" du profil.</p>
      <p>
        Je dois les mettre à jour en cas de changement de fonction ou de ville, car elles ne seront pas récupérées à
        nouveau depuis l'annuaire.
      </p>
    </PAccordion>
    <PAccordion
      label="Dimensions du rectangle de prépositionnement"
      label-tag="h2"
      class="py-1 [&>button]:border-grey-625 border-b-grey-625"
    >
      <p>
        J'importe les dimensions du rectangle "jaune" de prépositionnement de la signature qui sera utilisée. Pour cela,
        je recherche le nom du signataire et je sélectionne la signature prévue.
      </p>
      <p>Ou bien, si les connais, je saisis directement les dimensions.</p>
    </PAccordion>
    <PAccordion
      label="Exporter ses parapheurs"
      label-tag="h2"
      class="py-1 [&>button]:border-grey-625 border-b-grey-625"
    >
      <p>Les parapheurs actifs entre les deux dates renseignées vous seront transmis grâce à un lien envoyé par mél</p>
    </PAccordion>
    <PAccordion label="Badges" label-tag="h2" class="py-1 [&>button]:border-grey-625 border-b-grey-625">
      <p>
        Je peux activer jusqu'à
        {{ userPreferencesStore.maxActivatedTags }} badges parmi ceux disponibles, et je peux demander la création de
        nouveaux badges.
      </p>
    </PAccordion>
    <PAccordion label="Absence" label-tag="h2" class="py-1 [&>button]:border-grey-625 border-b-grey-625">
      <p>Je peux déclarer une période d'absence.</p>
      <p>
        Durant toute cette période d'absence,
        <OhVueIcon :name="absenceIcon" />
        sera visible à gauche de mon nom, dans le flux des parapheurs.
      </p>
      <p>Cette déclaration est strictement interne au Parapheur. Et n'est pas remontée dans l'annuaire.</p>
    </PAccordion>
  </div>
</template>

<script setup lang="ts">
import { PAccordion, PButton, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { FaCalendarTimes, RiCheckboxCircleFill, RiUser3Fill } from "oh-vue-icons/icons";
import { useUserPreferencesStore } from "../../stores/user-preferences.store.ts";

const userPreferencesStore = useUserPreferencesStore();

const [checkIcon, userProfileIcon, absenceIcon] = useIcons(RiCheckboxCircleFill, RiUser3Fill, FaCalendarTimes);
</script>
